export type Locale = 'en' | 'ar'
export type Direction = 'ltr' | 'rtl'

export const translations = {
  en: {
    header: {
      about: 'About',
      corporateGovernance: 'Corporate Governance',
      advisorsAuditors: 'Advisors & Auditors',
      cardIssuing: 'Card Issuing & Management',
      atmAcquiring: 'ATM Acquiring',
      merchantAcquiring: 'Merchant Acquiring',
      mobilePayment: 'Mobile Payment',
      consultancy: 'Consultancy',
      otherServices: 'Other Services',
      ourTools: 'Our Tools',
      theGroup: 'The Group',
      businesses: 'Businesses',
      partners: 'Partners',
      contact: 'Contact',
    },
    hero: {
      slide1: {
        heading: 'Seamless Payments.\nSmarter Solutions.',
        description:
          'Driving growth through empowering your business with state-of-the-art technology, agility, and security.',
      },
      slide2: {
        heading: 'Global Reach.\nLocal Expertise.',
        description:
          'Connecting businesses across 30+ countries with tailored payment solutions built for every market.',
      },
      learnMore: 'Learn More',
      scrollDown: 'Scroll Down',
    },
    stats: {
      clients: 'Clients',
      countries: 'Countries',
      experience: 'Year of Experience',
      employees: 'Employees',
    },
    about: {
      theGroup: 'The Group',
      description:
        'We empower financial ecosystems across more than 30 markets in the European, MENA, Central Asian, and Sub-Saharan Africa regions, partnering with over 100 banks and financial institutions to drive efficiency, scalability, and digital transformation.',
      learnMore: 'Learn More',
    },
    services: {
      title: 'Our Services',
      cardIssuing: {
        title: 'Card Issuing',
        description:
          'We offer comprehensive, end-to-end solutions for both physical and digital card programs.',
      },
      atmAcquiring: {
        title: 'ATM Acquiring',
        description:
          'Empowers financial institutions with seamless connectivity to local and international networks.',
      },
      mobilePayments: {
        title: 'Mobile Payments',
        description:
          "We enable financial institutions to meet the demands of today's digital-first users.",
      },
      merchantAcquiring: {
        title: 'Merchant Acquiring',
        description:
          'Flexible and scalable Merchant Acquiring platform designed to support businesses.',
      },
      consultancy: {
        title: 'Consultancy',
        description:
          'Consultancy services to help institutions navigate the complexities of the payments.',
      },
    },
    appExperience: {
      title: 'The App Experience',
      manageAccounts: {
        title: 'Manage All Card Accounts',
        content:
          "For access to all information related to their cardholders' accounts or transactions in a real-time online fashion.",
      },
      transactionSummary: {
        title: 'Transaction Summary',
        content:
          'View detailed transaction histories, filter by date or type, and export reports instantly.',
      },
      accountSummary: {
        title: 'Account Summary',
        content:
          'Get a comprehensive overview of your account balances, limits, and status at a glance.',
      },
      learnMore: 'Learn More',
    },
    security: {
      security: {
        title: 'Security',
        subtitle: '& Compliance',
        description:
          'We offer comprehensive risk and compliance management, including twice-daily card scrubbing against OFAC and other regulatory lists. Our tailored fraud detection and management solutions ensure robust protection, while dedicated customer support handles chargebacks and disputes efficiently.',
      },
      fraud: {
        title: 'Fraud',
        subtitle: '& Prevention',
        description:
          'Advanced fraud detection systems powered by machine learning analyze transactions in real-time, identifying suspicious patterns and preventing unauthorized access before it impacts your business.',
      },
      data: {
        title: 'Data',
        subtitle: '& Protection',
        description:
          'End-to-end encryption and secure data handling practices ensure your sensitive information remains protected at every stage of the transaction process, meeting global compliance standards.',
      },
    },
    partners: {
      description:
        'CSC Group Endeavors to facilitate commercial transactions through easy, direct, and targeted electronic payments. Over and above, CSC Group provides electronic and digital solutions that help businesses and clients obtain what they need in the shortest time possible.',
      learnMore: 'Learn More',
    },
    trusted: {
      title: 'Trusted By\nGlobal Leaders',
      description:
        "We are proud to partner with some of the world's most respected financial networks and institutions to deliver world-class payment solutions.",
      learnMore: 'Learn More',
    },
    footer: {
      company: 'Company',
      services: 'Services',
      support: 'Support',
      about: 'About',
      history: 'History',
      missions: 'Missions & Vision',
      partners: 'Our Partners',
      mobileApp: 'Mobile App',
      cardIssuing: 'Card Issuing & Management',
      atmAcquiring: 'ATM Acquiring',
      merchantAcquiring: 'Merchant Acquiring',
      dataCenters: 'Data Centers & Connections',
      mobilePayment: 'Mobile Payment',
      consultancy: 'Consultancy',
      beyondCore: 'Beyond The Core',
      tools: 'Tools',
      careers: 'Careers',
      contact: 'Contact us',
      privacy: 'Privacy Policy & Legal',
      dataPrivacy: 'Data Privacy Policy',
      copyright: '©2026 CSC Group , All Rights Reserved',
    },
    aboutPage: {
      hero: {
        title: 'ABOUT',
        subtitle:
          'Since our incorporation in 1993, CSC boasts over 30 years of proven expertise, establishing itself as a trusted leader in secure and innovative payment solutions.',
      },
      description: {
        paragraph1:
          'We empower financial ecosystems across more than 30 markets in the European, MENA, Central Asian, and Sub-Saharan Africa regions, partnering with over 100 banks and financial institutions to drive efficiency, scalability, and digital transformation.',
        paragraph2:
          "Operating from 4 strategically located sites, CSC Group delivers agile, future-ready technologies that meet the evolving needs of today's financial landscape, whether in card issuing, acquiring, or digital payments.",
      },
      teamQuote:
        'Our strength lies in our people, a diverse team of 200+ professionals committed to excellence, innovation, and client success.',
      mission: {
        label: 'Our Mission',
        heading:
          'Our mission is to empower our clients by delivering secure, innovative, and seamless payment processing solutions.',
        description:
          'We are committed to building trust through superior technology, exceptional service, and unwavering integrity, driving financial inclusion and growth for our clients and their communities.',
      },
      vision: {
        label: 'Our Vision',
        heading:
          'To lead the evolution of digital payments, pioneering secure innovations',
        description:
          'that unlock financial empowerment and prosperity for businesses and communities across our key markets.',
      },
      cta: {
        heading: 'Join Our\nBold Thinkers',
        description:
          "We're building the future of payments and we're looking for bold thinkers to join us.",
        button: 'Join Today',
      },
    },
  },
  ar: {
    header: {
      about: 'عن المجموعة',
      corporateGovernance: 'حكومة الشركات',
      advisorsAuditors: 'المستشارون والمدققون',
      cardIssuing: 'إصدار وإدارة البطاقات',
      atmAcquiring: 'شبكة الصراف الآلي',
      merchantAcquiring: 'خدمات التجار',
      mobilePayment: 'الدفع عبر الهاتف المحمول',
      consultancy: 'الاستشارات',
      otherServices: 'خدمات أخرى',
      ourTools: 'أدواتنا',
      theGroup: 'المجموعة',
      businesses: 'الأعمال',
      partners: 'الشركاء',
      contact: 'اتصل بنا',
    },
    hero: {
      slide1: {
        heading: 'مدفوعات سلسة.\nحلول أذكى.',
        description:
          'ندفع عجلة النمو من خلال تمكين أعمالك بأحدث التقنيات والمرونة والأمان.',
      },
      slide2: {
        heading: 'وصول عالمي.\nخبرة محلية.',
        description:
          'نربط الشركات عبر أكثر من 30 دولة بحلول دفع مخصصة مصممة لكل سوق.',
      },
      learnMore: 'اعرف المزيد',
      scrollDown: 'مرر للأسفل',
    },
    stats: {
      clients: 'عميل',
      countries: 'دولة',
      experience: 'سنة خبرة',
      employees: 'موظف',
    },
    about: {
      theGroup: 'المجموعة',
      description:
        'نحن نمكن الأنظمة المالية البيئية عبر أكثر من 30 سوقاً في أوروبا والشرق الأوسط وشمال أفريقيا وآسيا الوسطى وأفريقيا جنوب الصحراء الكبرى، ونشترك مع أكثر من 100 بنك ومؤسسة مالية لدفع الكفاءة وقابلية التوسع والتحول الرقمي.',
      learnMore: 'اعرف المزيد',
    },
    services: {
      title: 'خدماتنا',
      cardIssuing: {
        title: 'إصدار البطاقات',
        description:
          'نقدم حلولاً شاملة ومتكاملة لبرامج البطاقات المادية والرقمية.',
      },
      atmAcquiring: {
        title: 'شبكة الصراف الآلي',
        description:
          'تمكين المؤسسات المالية من الاتصال السلس بالشبكات المحلية والدولية.',
      },
      mobilePayments: {
        title: 'الدفع عبر الهاتف',
        description:
          'نمكن المؤسسات المالية من تلبية متطلبات المستخدمين الرقميين اليوم.',
      },
      merchantAcquiring: {
        title: 'خدمات التجار',
        description:
          'منصة مرنة وقابلة للتوسع لخدمات التجار مصممة لدعم الشركات.',
      },
      consultancy: {
        title: 'الاستشارات',
        description:
          'خدمات استشارية لمساعدة المؤسسات على التنقل في تعقيدات المدفوعات.',
      },
    },
    appExperience: {
      title: 'تجربة التطبيق',
      manageAccounts: {
        title: 'إدارة جميع حسابات البطاقات',
        content:
          'للوصول إلى جميع المعلومات المتعلقة بحسابات حاملي البطاقات أو المعاملات بشكل فوري عبر الإنترنت.',
      },
      transactionSummary: {
        title: 'ملخص المعاملات',
        content:
          'عرض سجلات المعاملات التفصيلية، والتصفية حسب التاريخ أو النوع، وتصدير التقارير فورياً.',
      },
      accountSummary: {
        title: 'ملخص الحساب',
        content: 'احصل على نظرة شاملة لأرصدة حسابك وحدوده وحالته في لمحة.',
      },
      learnMore: 'اعرف المزيد',
    },
    security: {
      security: {
        title: 'الأمان',
        subtitle: '& الامتثال',
        description:
          'نقدم إدارة شاملة للمخاطر والامتثال، بما في ذلك فحص البطاقات مرتين يومياً مقابل قوائم العقوبات واللوائح الأخرى. تضمن حلولنا المخصصة للكشف عن الاحتيال وإدارته حماية قوية، بينما يتعامل دعم العملاء المخصص مع عمليات رد المبالغ المدفوعة والنزاعات بكفاءة.',
      },
      fraud: {
        title: 'الاحتيال',
        subtitle: '& الوقاية',
        description:
          'تحلل أنظمة الكشف عن الاحتيال المتقدمة المدعومة بالتعلم الآلي المعاملات في الوقت الفعلي، وتحدد الأنماط المشبوهة وتمنع الوصول غير المصرح به قبل أن يؤثر على عملك.',
      },
      data: {
        title: 'البيانات',
        subtitle: '& الحماية',
        description:
          'يضمن التشفير الشامل وممارسات معالجة البيانات الآمنة بقاء معلوماتك الحساسة محمية في كل مرحلة من مراحل عملية المعاملة، مما يلبي معايير الامتثال العالمية.',
      },
    },
    partners: {
      description:
        'تسعى مجموعة CSC لتسهيل المعاملات التجارية من خلال مدفوعات إلكترونية سهلة ومباشرة ومستهدفة. وعلاوة على ذلك، توفر مجموعة CSC حلولاً إلكترونية ورقمية تساعد الشركات والعملاء في الحصول على ما يحتاجون إليه في أقصر وقت ممكن.',
      learnMore: 'اعرف المزيد',
    },
    trusted: {
      title: 'موثوق به من قبل\nقادة عالميين',
      description:
        'نحن فخورون بالشراكة مع بعض الشبكات والمؤسسات المالية الأكثر احتراماً في العالم لتقديم حلول دفع عالمية المستوى.',
      learnMore: 'اعرف المزيد',
    },
    footer: {
      company: 'الشركة',
      services: 'الخدمات',
      support: 'الدعم',
      about: 'عن الشركة',
      history: 'التاريخ',
      missions: 'المهام والرؤية',
      partners: 'شركاؤنا',
      mobileApp: 'تطبيق الهاتف',
      cardIssuing: 'إصدار وإدارة البطاقات',
      atmAcquiring: 'شبكة الصراف الآلي',
      merchantAcquiring: 'خدمات التجار',
      dataCenters: 'مراكز البيانات والاتصالات',
      mobilePayment: 'الدفع عبر الهاتف',
      consultancy: 'الاستشارات',
      beyondCore: 'ما وراء الأساسيات',
      tools: 'الأدوات',
      careers: 'الوظائف',
      contact: 'اتصل بنا',
      privacy: 'سياسة الخصوصية والقانونية',
      dataPrivacy: 'سياسة خصوصية البيانات',
      copyright: '©2026 مجموعة CSC، جميع الحقوق محفوظة',
    },
    aboutPage: {
      hero: {
        title: 'عن المجموعة',
        subtitle:
          'منذ تأسيسنا في عام 1993، تفتخر CSC بأكثر من 30 عاماً من الخبرة المثبتة، مما يرسخ مكانتها كشريك موثوق في حلول الدفع الآمنة والمبتكرة.',
      },
      description: {
        paragraph1:
          'نحن نمكّن الأنظمة المالية عبر أكثر من 30 سوقاً في مناطق أوروبا والشرق الأوسط وشمال أفريقيا وآسيا الوسطى وأفريقيا جنوب الصحراء، بالشراكة مع أكثر من 100 بنك ومؤسسة مالية لتعزيز الكفاءة وقابلية التوسع والتحول الرقمي.',
        paragraph2:
          'انطلاقاً من 4 مواقع استراتيجية، تقدم مجموعة CSC تقنيات مرنة ومستقبلية تلبي الاحتياجات المتطورة للمشهد المالي اليوم، سواء في إصدار البطاقات أو التشغيل أو المدفوعات الرقمية.',
      },
      teamQuote:
        'تكمن قوتنا في موظفينا، فريق متنوع يضم أكثر من 200 محترف ملتزمين بالتميز والابتكار ونجاح العملاء.',
      mission: {
        label: 'مهمتنا',
        heading:
          'مهمتنا هي تمكين عملائنا من خلال تقديم حلول معالجة مدفوعات آمنة ومبتكرة وسلسة.',
        description:
          'نحن ملتزمون ببناء الثقة من خلال التكنولوجيا المتفوقة والخدمة الاستثنائية والنزاهة الراسخة، مما يدفع الشمول المالي والنمو لعملائنا ومجتمعاتهم.',
      },
      vision: {
        label: 'رؤيتنا',
        heading: 'قيادة تطور المدفوعات الرقمية وريادة الابتكارات الآمنة',
        description:
          'التي تطلق العنان للتمكين المالي والازدهار للشركات والمجتمعات عبر أسواقنا الرئيسية.',
      },
      cta: {
        heading: 'انضم إلى\nمفكرينا الجريئين',
        description:
          'نحن نبني مستقبل المدفوعات ونبحث عن مفكرين جريئين للانضمام إلينا.',
        button: 'انضم اليوم',
      },
    },
  },
}
